<template>

		<div v-if='fileName == "" || fileName.match(/pdf/g) == null'>
      <div id="upload"  class="form-group commonStyle styleA" v-bind:class="{'isImage':isFile}" :style="{background: 'url(' + fileURL + ')'}"  @drop.prevent="uploadFile($event) " >
        <label :for="keyName + indexImage" class="button" :class='{"isImage":isFile}' >
          <p v-if='!isFile' >＋</p>
          <input :id="keyName + indexImage" type="file" name="img" @change="uploadFile($event)" style="display:none;" accept="image/*,application/pdf">
        </label>

        <p v-if='!isFile' >{{$t("message.click_upload")}}</p>
        <p v-if='!isFile'>{{$t("message.image_drop")}}</p>

      </div>

    </div>
    <div v-else class="test">
      <a target="_blank" :href="fileURL">{{fileName}} </a>
    </div>
</template>
<script>
export default {
	props:{
    fileURL: {
      type: String,
      default: null
    },
    keyName: {
      type: String,
      default: ""
    },
    indexImage: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      file:"",
      isFile: false,
      fileName: '',
      fileImage: null,
    }
  },
  methods: {
    uploadFile: function(event){
      this.styleA = true;
      const files = event.target.files ? event.target.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
        this.isFile = true
        this.fileImage = event.target.result;
        this.$emit('changeFile', {fileImage: this.fileImage, keyName: this.keyName, index: this.indexImage})
      };
      this.fileName = file.name;

      if(this.fileName.match(/pdf/g) == null){
        reader.readAsDataURL(file);
      }else{
        this.fileURL = URL.createObjectURL(file)
      }
      document.getElementById('upload').files = files;
    }
  }
}

</script>
<style type="text/css">
.commonStyle{
  padding: 2rem;
  text-align:center;
}
.styleA{
  border:3px dotted gray;
  background-color: #F5F5F8 !important;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}

.isImage{
  min-height: 150px;
  background-position : center !important;
}
</style>t